<div class="ln-dropdown">
  <button
    type="button"
    class="ln-dropdown__btn"
    [style.min-width]="minWidth"
    [style.min-height]="minHeight"
    [disabled]="disabled"
    (click)="toggle()"
  >
    @if (leadIcon) {
      <i
        class="ln-dropdown__lead-icon"
        [class.ln-dropdown__lead-icon--green]="leadIconAccent"
        [ngClass]="leadIcon"
        aria-hidden="true"
      ></i>
    }
    <span class="ln-dropdown__label" [class.ln-dropdown__label--placeholder]="isPlaceholder">{{ buttonLabel }}</span>
    <i class="fa fa-chevron-down ln-dropdown__chevron" aria-hidden="true"></i>
  </button>
  @if (open) {
    @if (searchable) {
      <div
        class="ln-dropdown__menu ln-dropdown__menu--searchable"
        [class.ln-dropdown__menu--right]="menuAlign === 'right'"
      >
        <div class="ln-dropdown__search">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input
            type="text"
            class="ln-dropdown__search-input"
            [placeholder]="searchPlaceholder"
            [(ngModel)]="searchTerm"
            (click)="$event.stopPropagation()"
          />
        </div>
        <ul class="ln-dropdown__list" [style.max-height]="menuMaxHeight">
          @for (option of filteredOptions; track option.value) {
            <li
              class="ln-dropdown__item"
              [class.ln-dropdown__item--active]="isActive(option)"
              (click)="select(option)"
            >
              {{ option.label }}
            </li>
          }
          @if (filteredOptions.length === 0) {
            <li class="ln-dropdown__empty">No matches found</li>
          }
        </ul>
      </div>
    } @else {
      <ul
        class="ln-dropdown__menu"
        [class.ln-dropdown__menu--right]="menuAlign === 'right'"
      >
        @for (option of normalizedOptions; track option.value) {
          <li
            class="ln-dropdown__item"
            [class.ln-dropdown__item--active]="isActive(option)"
            (click)="select(option)"
          >
            {{ option.label }}
          </li>
        }
      </ul>
    }
  }
</div>
